var map = {
	"./fall2022/compiled_course_data.json": 976,
	"./fall2023/compiled_course_data.json": 89,
	"./fall2024/compiled_course_data.json": 2,
	"./fall2025/compiled_course_data.json": 419,
	"./fall2026/compiled_course_data.json": 804,
	"./spring2022/compiled_course_data.json": 496,
	"./spring2023/compiled_course_data.json": 545,
	"./spring2024/compiled_course_data.json": 794,
	"./spring2025/compiled_course_data.json": 91,
	"./spring2026/compiled_course_data.json": 764,
	"./spring2027/compiled_course_data.json": 13
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 312;